import {
  BUTTON_HEIGHT_QUICK_VIEW,
  DisplaySize,
  FONT_SIZE_VALUE,
} from "@lhd/constants";
import { DISPLAY_SIZES } from "@lhd/types";
import ButtonArrowDown, { ButtonArrowProps } from "../ButtonArrowDown";

interface ButtonQuickViewProps
  extends Omit<ButtonArrowProps, "name" | "fontSize"> {
  name?: string;
  fontSize?: number;
  displaySize?: DisplaySize;
}
const ButtonQuickView = (props: ButtonQuickViewProps) => {
  const displaySize = props.displaySize || DISPLAY_SIZES.SMALL;

  const fontSize = FONT_SIZE_VALUE[displaySize] || FONT_SIZE_VALUE.small;
  const height =
    BUTTON_HEIGHT_QUICK_VIEW[displaySize] || BUTTON_HEIGHT_QUICK_VIEW.small;

  return (
    <ButtonArrowDown
      name="下見"
      fontSize={fontSize}
      height={height}
      {...props}
    />
  );
};

export default ButtonQuickView;
